import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import remark from 'remark';
import strip from 'strip-markdown';
import config from '../siteConfig';
import PostHeader from './PostHeader';
import PostFooter from './PostFooter';
import Seo from './Seo';

const PostExcerpt = props => {
  const { post } = props;
  const tokenIndex = post.html.indexOf('<div id="excerpt-continue">');
  const excerpt = tokenIndex > 0 ? post.html.substring(0, tokenIndex) : post.html;

  const postSeo = {
    type: 'CreativeWork',
    title: post.frontmatter.title,
    description: remark()
      .use(strip)
      .processSync(post.excerpt)
      .toString(),
    author: post.frontmatter.author,
    datePublished: post.frontmatter.datePublishedRaw,
    dateModified: post.frontmatter.dateModifiedRaw,
  };

  return (
    <article className="blog-post-excerpt">
      <Seo pageSeo={postSeo} />
      <PostHeader frontMatter={post.frontmatter} />
      <div className="blog-post--content">
        <div dangerouslySetInnerHTML={{ __html: excerpt }} />
        <p>
          <Link to={`${config.routePosts}/${post.frontmatter.slug}#excerpt-continue`}>
            [Read more…]
            <span className="is-sr">about {post.frontmatter.title}</span>
          </Link>
        </p>
      </div>
      <PostFooter frontMatter={post.frontmatter} />
    </article>
  );
};

PostExcerpt.propTypes = {
  post: PropTypes.shape({
    excerpt: PropTypes.string,
    frontmatter: PropTypes.object,
    html: PropTypes.string,
  }),
};

PostExcerpt.defaultProps = {
  post: {},
};

export default PostExcerpt;



// WEBPACK FOOTER //
// ./src/components/PostExcerpt.js